import { render, staticRenderFns } from "./ProductStockModal.vue?vue&type=template&id=fa8e53c2&scoped=true"
import script from "./ProductStockModal.vue?vue&type=script&lang=js"
export * from "./ProductStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8e53c2",
  null
  
)

export default component.exports